import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IState {
  page: number;
}

const initialState: IState = { page: 3 };

export const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    changePage: (state, action: PayloadAction<number>) => {
      return { ...state, page: action.payload };
    },
  },
});

export const { changePage } = pageSlice.actions;

export default pageSlice.reducer;
